import { Component } from 'react';
import { isTrue } from '../../../../helpers/isTrue';
import DeleteLinkedUser from '../../../../modules/DeleteLinkedUser';
import ConfirmationModal from '../../ManageAccount/Modal';
import { withTranslation } from 'react-i18next';

class LinkedAccounts extends Component {
    constructor() {
        super();
        this.linkedAccounts = window.linkedAccounts ?? [];
        this.onToggleModal = this.onToggleModal.bind(this);

        try {
            this.permission_errors = JSON.parse(this.props.permission_errors) ?? [];
        } catch (err) {
            this.permission_errors = [];
        }
        try {
            this.grant_error_linked_accounts =
                JSON.parse(this.props.grant_error_linked_accounts) ?? [];
        } catch (err) {
            this.grant_error_linked_accounts = [];
        }

        this.state = {
            isOpenModal: false,
        };
    }

    onToggleModal() {
        this.setState({
            isOpenModal: !this.state.isOpenModal,
        });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="settings-card settings-linked-accounts">
                    <div className="settings-linked-accounts-header">
                        {t('settings.linked_accounts.header')}
                        {!isTrue(this.props.is_deactivated) && (
                            // <a href="/customers/link" className="button button-filled button-primary">
                            //     Add Account
                            // </a>
                            <button
                                onClick={this.onToggleModal}
                                className="button button-filled button-primary"
                            >
                                {t('settings.linked_accounts.add_account')}
                            </button>
                        )}
                    </div>
                    <div className="settings-linked-accounts-body">
                        {this.linkedAccounts.length ? (
                            this.linkedAccounts?.map((item, i) => (
                                <div key={i} className="settings-linked-accounts-item">
                                    <div className="settings-linked-accounts-item-left">
                                        <img src={item.picture} />
                                        <div className="settings-linked-accounts-item-left-text-container">
                                            <div className="settings-linked-accounts-item-left-text">
                                                <div>
                                                    {item.given_name} {item.family_name}
                                                </div>
                                                {item.client_email && (
                                                    <div className="settings-linked-accounts-item-left-text-bottom">
                                                        {item.client_email}{' '}
                                                        <span className="email-address-container">
                                                            {t('settings.linked_accounts.added_by')}{' '}
                                                            <span className="email-address">
                                                                {item.added_by_user_username}
                                                            </span>
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            {this.grant_error_linked_accounts.includes(
                                                item.a_id,
                                            ) && (
                                                <span>
                                                    <i className="icofont-warning link-danger mr-10"></i>
                                                    <a
                                                        href="/customers/link/"
                                                        style={{
                                                            color: '#1F4384',
                                                            textDecoration: 'underline',
                                                        }}
                                                    >
                                                        {this.props.message}
                                                    </a>
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    {!this.grant_error_linked_accounts.includes(item.a_id) ? (
                                        <a
                                            href={`/domains/link?account=${item.a_id}`}
                                            className="settings-action-btn"
                                            title="Add domain(s)"
                                        >
                                            +
                                        </a>
                                    ) : (
                                        <DeleteLinkedUser
                                            account_id={item.a_id}
                                            user_email={item.client_email}
                                        />
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="settings-linked-accounts-item-left-text">
                                {t('settings.linked_accounts.no_linked_accounts')}
                            </div>
                        )}
                        {this.permission_errors &&
                            this.permission_errors?.map((item, i) => {
                                <div className="permissions-errors-message" key={i}>
                                    {t('settings.linked_accounts.permission_error_message', {
                                        domain: item.domain,
                                    })}
                                </div>;
                            })}
                    </div>
                </div>
                <ConfirmationModal isOpen={this.state.isOpenModal} onClose={this.onToggleModal} />
            </>
        );
    }
}

export default withTranslation()(LinkedAccounts);
